export const locale = {
  lang: 'ar',
  data: {
    MENU: {
      DASHBOARD: {
        COLLAPSIBLE: "لوحة التحكم",
        BADGE: "2",
        ANALYTICS: "الإحصائيات",
        ECOMMERCE: "التجارة الإلكترونية",
        "HOME": "الرئيسية ",
        "SAMPLE": "عينة ",
        "users": "المستخدمين",
        "list": "القائمة",
              "MISSED_PRAYERS": "الصلوات الفائتة",
                "Active": "نشط",   
 "Details": "التفاصيل",
     "LESSONS": "الدروس",

      "categories_list": "قائمة الأذكار",
"USERS_LIST": "قائمة المستخدمين",
      "SEARCH": "بحث",
      "daily_users": "المستخدمون اليوميون",
      "prayer_makeup": "قضاء الصلوات",
            "religious_inquiries_list": "قائمة الاستفسارات الشرعية",
      "participation_engagement": "المشاركة والتفاعل",
      "zakat": "الزكاة",
      "ramadan_missed": "فوائت رمضان",
      "fatwa": "الفتوى",
      "MISSED_FASTING": "الصيام الفائت",
      "religious_inquiries": "الاستفسارات الشرعية",
"REMAINING_DAYS": "الأيام المتبقية",
"REASON": "السبب",
"PENDING": "غير مكتمل",
      "fiqh": "الفقه",
       "DAILY_USERS_LIST": "قائمة المستخدمين اليوميين",
      "PRAYER_MAKEUP_LIST": "قائمة قضاء الصلوات",
      "PARTICIPATION_ENGAGEMENT_LIST": "قائمة المشاركة والتفاعل",
      "ZAKAT_LIST": "قائمة الزكاة",
      "RAMADAN_MISSED_FASTS_LIST": "قائمة فوائت صيام رمضان",
      "FATWA_LIST": "قائمة الفتاوى",
      "FIQH_LIST": "قائمة الفقه",
      "ASK_MUFTI_LIST": "قائمة أسئلة المفتي",
      "ask_mufti": "اسأل المفتي",
      "MISSED_PRAYERS_LIST": "قائمة الصلوات الفائتة",
    "Expired": "منتهي",
        "add": "إضافة",
        "SOCIAL_LINKS_LIST": "قائمة روابط التواصل",
      "ON_BOARDING_LIST": "قائمة التهيئة",
 "EDIT": "تعديل",
  "items": "العناصر",
      "items_list": "قائمة العناصر",
      "DELETE": "حذف",
      "IMAGE": "الصورة",
      "TITLE": "العنوان",
       "NEW_USERS": "المستخدمين الجدد",
      "NEW_USERS_TODAY": "مسجلين جدد اليوم",
      "TOTAL_ELIMINATION": "إجمالي القضاء",
      "TOTAL_ELIMINATION_TODAY": " إجمالي القضاء اليوم",
      "USER_DETAILS": "تفاصيل المستخدم",
      "NAME": "الاسم",
      "EMAIL": "البريد الإلكتروني",
      "CITY": "المدينة",
      "COUNTRY": "الدولة",
      "UPDATED_AT": "آخر تحديث",
      "PROGRESS": "التقدم",

       "Select_User": "اختر مستخدم",
      "PRIVACY_POLICY": "سياسة الخصوصية",
 "NOTIFICATIONSs": {
    "ADD": "إضافة إشعار",
    "EDIT": "تعديل الإشعار",
  }, "WELCOME_MESSAGE": "مرحباً بعودتك 👋",
      "TOTAL_USERS": "إجمالي المستخدمين",
      "MONTHS": "الأشهر الفائتة",
      "TOTAL_DAYS": "إجمالي الأيام",
      "COMPLETED": "مكتمل",
      "DETAILS": "التفاصيل",
      "CREATED_AT": "تاريخ الإنشاء",
      "NO": "لا",
        "SHOW": "عرض",
          "ENTRIES": "مدخلات",
      "Type": "النوع",
      "errorLogin": "البريد الإلكتروني أو كلمة المرور غير صحيحة، حاول مرة أخرى.",
      "Read": "تمت القراءة",
      "Unread": "غير مقروء",
      "Save_Changes": "حفظ التغييرات",
            "PRIVACY_POLICY_LIST": "قائمة سياسة الخصوصية",
 "AUTH": {
    "LOGIN": {
      "TITLE": "رفيق دربك",
      "SUBTITLE": "يرجى تسجيل الدخول إلى حسابك وبدء الرحلة",
      "EMAIL": "البريد الإلكتروني",
      "EMAIL_PLACEHOLDER": "أدخل البريد الإلكتروني",
      "EMAIL_REQUIRED": "البريد الإلكتروني مطلوب",
      "EMAIL_INVALID": "يرجى إدخال بريد إلكتروني صحيح",
      "PASSWORD": "كلمة المرور",
      "PASSWORD_REQUIRED": "كلمة المرور مطلوبة",
      "SIGN_IN": "تسجيل الدخول",
      "CHANGE_LANG_EN": "English",
      "CHANGE_LANG_AR": "العربية"
    }
  },
        "User_ID": "معرف المستخدم",
      "Title": "العنوان",
      "Message": "الرسالة",
       "TITLEE": "شاشات البداية",
        "Link": "الرابط",
              "ADD_SOCIAL_LINK": "إضافة رابط تواصل اجتماعي"
,
      "Platform": "المنصة",
      "LIST_TITLEE": "قائمة شاشات البداية",
      "name_ar": "الاسم بالعربية",
      "CHANGE_LANGUAGE": {
      "LABEL": "تغيير اللغة",},
      "name_en": "الاسم بالإنجليزية",
      "Image": "الصورة",
            "Description": "الوصف",
      "Add": "إضافة",
      "DESCRIPTION": "الوصف",
      "ORDER": "الترتيب",
       "ENABLED": "مفعلة",
             "AddOnBoarding": "إضافة شاشة بداية"
,      "Select_Platform": "اختر المنصة"
,
      "DISABLED": "غير مفعلة",
      "YES": "نعم",
      "DATE": "التاريخ",
        "ads": "الإعلانات",
         "NOTIFICATIONS_LIST": "قائمة الإشعارات",
      "ID": "المعرف",
      "READ": "مقروء",
      "UNREAD": "غير مقروء",
      "ACTIONS": "الإجراءات",
      "SAVE": "حفظ",
      "CANCEL": "إلغاء",
        "counselors": "المستشارين",
        "stores_offers": "عروض المتاجر",
        "cancelation_reason": "سبب الإلغاء",
        "companies": "الشركات",
         "NOTIFICATIONS": "الإشعارات",
      "SOCIAL_LINKS": "روابط التواصل",
      "ON_BOARDING": "التهيئة",
            "EDIT_SOCIAL_LINKS": "تعديل روابط التواصل الاجتماعي",

        "consulting": "الاستشارات",
        "categories": "الأذكار",
        "services": "الخدمات",
        "tags": "العلامات",
        "articles": "المقالات",
        "offers": "العروض",
        "plantcards": "بطاقات النباتات",
      "MISSED_PRAYERS_TODAY": "الصلوات الفائتة اليوم",
        "Settings": "الإعدادات",
    "ShowDetails": "عرض التفاصيل",
    "TermsAndConditions": "الشروط والأحكام",
    "About": "حول",
    "Notifications": "الإشعارات",
    "Currencies": "العملات",
    "Countries": "الدول",
    "Cities": "المدن",
    "plans": "الخطط",
      "light": "الضوء",
      "root": "الجذر",
      "seed": "البذرة",
      "soil": "التربة",
      "stem": "الجذع",
      "counselorspayment": "دفع المستشارين",
      "OpenScreens": "الشاشات المفتوحة",
    "GanatakCommunity": "مجتمع جانتاك",
    "Paperform": "نموذج الورقة",
    "Sizes": "الأحجام",
    "Sliders": "المنزلقات"

      },
      USERS_SECTION: "العملاء",
      USERS: {
        LIST: "قائمة المستخدمين",
        ADD: "إضافة مستخدم"
      },
      PRODUCTS: {
        Title: "المنتجات",
        LIST: "قائمة المنتجات",
        AT_HOME: "منتجات في المنزل"
      },
      COUNSELORS: {
        Title: "المستشارين",
        LIST: "قائمة الاستشاريين",
        ADD: "إضافة استشاري"
      },
      STORES: {
        Title: "المتاجر",
        LIST: "قائمة المتاجر",
        ADD: "إضافة متجر"
      },
      STORES_OFFERS: {
        Title: "عروض المتاجر",
        LIST: "قائمة العروض"
      }, VOUCHER: {
        Title: "العروض الترويجية",
        TYPE: "أنواع العروض الترويجية",
        LIST: "قائمة العروض الترويجية"
      }, cancelation_reasons: {
        Title: "سبب الالغاء",
        LIST: "قائمة أسباب الإلغاء",
        ADD: "إضافة سبب"
      },
      COMPANIES: {
        Title: "الشركات",
        LIST: "قائمة الشركات",
        ARCHIVED: "الشركات المؤرشفة",
        "ADD": "إضافة شركة"
      },
      consulting: {
        Title: "الاستشارات",
        LIST: "قائمة الاستشارات",
      }, SERVICES: {
        Title: "الخدمات",
        LIST: "قائمة الخدمات",
        ADD: "إضافة خدمة"
      },
      SECTION: {
        Title: "الاقسام",
        LIST: "قائمة الاقسام",
        TYPES: "انواع القسائم",
        ADD: "إضافة قسم"

      },
      ARTICLES: {
        Title: "المقالات",
        LIST: "قائمة المقالات",
        Plant_groups: "المجموعات النباتية",
        ADD: "إضافة ",
        various: "مقالات زراعية متنوعة",
      },
      TAGS: {
        Title: "التاجات",
        LIST: "قائمة التاجات",
        ADD: "إضافة علامة"
      },
      offers: {
        Title: "العروض",
        LIST: "قائمة العروض",
        ADD: "إضافة عروض"
      },
      reasone_canceled: {
        Title: "سبب الالغاء",
        LIST: "قائمة ",
        ADD: "إضافة"
      },

      "PLANTCARDS": {
        "TITLE": "بطاقات النباتات",
        "LIST": "قائمة بطاقات النباتات",
        "ADD": "إضافة بطاقة نبات",
        "LEAVERSCOLOR": {
          "TITLE": "ألوان أوراق النباتات",
          "LIST": "قائمة ألوان أوراق النباتات",
          "ADD": "إضافة لون لأوراق النباتات"
        },
        "LEAVERSFORM": {
          "TITLE": "أشكال أوراق النباتات",
          "LIST": "قائمة أشكال أوراق النباتات",
          "ADD": "إضافة شكل لأوراق النباتات"
        },
        "FLOWERFORM": {
          "TITLE": "أشكال الأزهار",
          "LIST": "قائمة أشكال الأزهار",
          "ADD": "إضافة شكل للأزهار"
        },
        "FLOWERCOLOR": {
          "TITLE": "ألوان الأزهار",
          "LIST": "قائمة ألوان الأزهار",
          "ADD": "إضافة لون للأزهار"
        },
        "ENVIRONMENTLIGHT": {
          "TITLE": "إضاءة البيئة",
          "LIST": "قائمة إضاءة البيئة",
          "ADD": "إضافة إضاءة بيئة"
        },
        "ENVIRONMENTTEMP": {
          "TITLE": "درجة حرارة البيئة",
          "LIST": "قائمة درجات حرارة البيئة",
          "ADD": "إضافة درجة حرارة بيئة"
        },
        "ENVIRONMENHUMIDITY": {
          "TITLE": "رطوبة البيئة",
          "LIST": "قائمة رطوبة البيئة",
          "ADD": "إضافة رطوبة بيئة"
        },
        "REPRODUCTIONS": {
          "TITLE": "التكاثر",
          "LIST": "قائمة طرق التكاثر",
          "ADD": "إضافة طريقة تكاثر"
        },
        "PLANTCARDSOIL": {
          "TITLE": "أنواع التربة",
          "LIST": "قائمة أنواع التربة",
          "ADD": "إضافة نوع تربة"
        },

        


 

      }

    }
  
  }
}
